(function homeGridModuleDefinition() {
    'use strict';

    angular.module('HomeGrid', [])
        .directive('crHomeGrid', ['$translate', 'errorsExtend', 'authExtend', 'storageService', '$state', 'documentContainerAction', 'alerts', 'documentContainerService', 'documentService', 'documentAction', 'favoritesService',
            function ($translate, errors, auth, storageService, $state, documentContainerAction, alerts, documentContainerService, documentService, documentAction, favoritesService) {
                return {
                    scope: {
                        gridName: '=',
                        header: '=',
                        //headerClassName: '=',
                        countLabel: '=',
                        data: '=',
                        activeGrid: '=',
                        countGrids: '=',
                        detail: '=',
                        view: '=',
                        modify: '=',
                        hideDetailButton: '=',
                        hideViewButton: '=',
                        hideDownloadButton: '=',
                        hideCheckOutButton: '=',
                        hideModifyButton: '=',
                        hideCheckedOutButton: '=',
                        hideAddToFavourite: '=',
                        showTypeColumn: '=',
                        showStatusIcons: '=',
                        reloadSearch: '&onReloadSearch',
                        accordionToogle: '&onToogleAccordion',
                        goDownload: '&onDownload'
                    },

                    controller: [
                        '$scope', '$element', function ($scope, $element) {
                            $scope.previous = function () {
                                if ($scope.data.data.currentPage > 1) {
                                    $scope.data.data.currentPage -= 1;
                                    $scope.data.grid = [];
                                    $scope.reloadSearch();
                                }
                            }

                            $scope.next = function () {
                                var maxPage = Math.ceil($scope.data.data.totalItems / $scope.data.data.itemsPerPage);

                                if ($scope.data.data.currentPage < maxPage) {
                                    $scope.data.data.currentPage += 1;
                                    $scope.data.grid = [];
                                    $scope.reloadSearch();
                                }
                            }

                            $scope.sort = function (header) {
                                $scope.data.sortedBy.header = header;
                                $scope.data.sortedBy.headerIndex = header === 'id' ? 0 : header === 'name' ? 1 : 2;
                                $scope.data.sortedBy.orderBy = header + ' ' + ($scope.data.sortedBy.asc ? 'DESC' : 'ASC');
                                $scope.data.sortedBy.asc = !$scope.data.sortedBy.asc;
                                $scope.data.grid = [];
                                $scope.reloadSearch();
                            }

                            $scope.goToDetail = function (ent) {
                                var stateName = $scope.detail;
                                if ($scope.detail.indexOf(',') > 0) {
                                    var splitted = $scope.detail.split(',');
                                    if (ent.type === 'CONTAINERS') {
                                        stateName = splitted[0];
                                    } else {
                                        stateName = splitted[1];
                                    }
                                }

                                storageService.setStateBackFind('');
                                $state.go(stateName, { id: ent.id });
                            }

                            $scope.goToView = function (ent) {
                                var stateName = $scope.view;
                                if ($scope.detail.indexOf(',') > 0) {
                                    var splitted = $scope.view.split(',');
                                    if (ent.type === 'CONTAINERS') {
                                        stateName = splitted[0];
                                    } else {
                                        stateName = splitted[1];
                                    }
                                }

                                storageService.setStateBackFind('');
                                if (ent.nroVersion) {
                                    $state.go(stateName, { id: ent.id, version: ent.nroVersion });
                                } else {
                                    $state.go(stateName, { id: ent.id });
                                }

                            }

                            $scope.goToModify = function (ent) {
                                var stateName = $scope.modify;
                                if ($scope.detail.indexOf(',') > 0) {
                                    var splitted = $scope.modify.split(',');
                                    if (ent.type === 'CONTAINERS') {
                                        stateName = splitted[0];
                                    } else {
                                        stateName = splitted[1];
                                    }
                                }

                                $state.go(stateName, { id: ent.id });
                            }

                            $scope.download = function (ent) {
                                $scope.goDownload({ ent: ent });
                            }

                            $scope.checkOut = function (ent) {
                                if (ent.type === 'CONTAINERS') {
                                    return $translate(['Warning', 'DocumentContainerCheckOutConfirmText', 'Yes', 'No'])
                                        .then(function (translated) {
                                            return alerts.confirm(translated.Warning, translated.DocumentContainerCheckOutConfirmText, translated.Yes, translated.No)
                                                .then(function getOk(result) {
                                                    if (!result) {
                                                        return result;
                                                    }
                                                    return documentContainerService.checkout(ent)
                                                        .then(function getOk(result) {
                                                            errors.showSuccess('DocumentContainerCheckOutSucces');
                                                            ent.IsCheckedOutByMe = true;
                                                            //$scope.searchMyWorkspace();
                                                        }, function (error) {
                                                            errors.showError(error);
                                                        });
                                                });
                                        });
                                } else {
                                    return documentService.checkout(ent).then(function () {
                                        ent.IsCheckedOutByMe = true;
                                        errors.showSuccess('DocumentCheckOutSucces');
                                        //$scope.searchMyWorkspace();
                                    }, function (error) {
                                        errors.showError(error);
                                    });
                                }
                            }

                            $scope.checkIn = function (ent) {
                                if (ent.type === 'CONTAINERS') {
                                    documentContainerAction.checkIn(ent).then(function getOk() {
                                        ent.IsCheckedOutByMe = false;
                                        //$scope.searchMyWorkspace();
                                    });
                                } else {
                                    return documentAction.checkIn(ent, ent.classId).then(function (doc) {
                                        ent.IsCheckedOutByMe = false;
                                        //$scope.searchMyWorkspace();
                                    });
                                }
                            }

                            $scope.addFavorite = function (ent, type) {
                                return favoritesService.addFavorite(ent.id, type).then(function getOk(result) {
                                    ent.favorited = true;
                                }, function getError(error) {
                                    errors.showError(error);
                                });
                            };

                            $scope.toogle = function (name) {
                                $scope.accordionToogle({ grid: name });
                            }
                        }],
                    restrict: 'E',
                    templateUrl: '/app/directives/home-grid/home-grid.html',
                    link: function ($scope) {
                        $scope.$watch('data', function (value) {
                            $scope.data = value;
                        });
                        $scope.$watch('activeGrid', function (value) {
                            $scope.activeGrid = value;
                        });
                        $scope.$watch('countGrids', function (value) {
                            $scope.countGrids = value;
                        });
                        $scope.$watch('headerClassName', function (value) {
                            $scope.headerClassName = value;
                        });
                    }
                };
            }
        ]);
})();